<template>
  <div class="">

    <Button
      :size="17"
      color="#107c41"
      colorText="#ffffff"
      tooltip="Reporte general Shipping Instructions"
      icon="fas fa-file-excel"
      round
      :width="35"
      class="ml-1 mr-3 mt-2"
      traslate
      @click.native="openModal('report_si_general')"
    />

    <ui-modal
      :align-top-margin="500"
      ref="report_si_general"
      title="Reporte general Shipping Instructions"
      @close="closeModal('report_si_general')"
      size="large"
      id="report_si_general">

      <div class="d-flex flex-column">

          <div class="d-flex mb--2">
            <div class="w-50 mr-2">
              <div class="d-flex flex-column mt-2 w-100">

                <div class="d-flex w-100" style="margin-bottom: -50px">

                  <div class="form-group col-4">
                    <label>Desde (*)</label>
                    <input class="form-control"
                           v-model="begin"
                           placeholder="Ingrese una fecha"
                           type="date"
                    />
                  </div>

                  <div class="form-group col-4">
                    <label>Hasta (*)</label>
                    <input class="form-control"
                           v-model="end"
                           placeholder="Ingrese una fecha"
                           type="date"
                    />
                  </div>

                  <div class="form-group col-4">
                    <label>Estado</label>
                    <select class="form-control" v-model="status">
                      <option value="">--Seleccione--</option>
                      <option value="por_enviar">Por enviar</option>
                      <option value="enviadas">Enviadas</option>
                      <option value="por_aprobar">Por aprobar</option>
                      <option value="por_realizar">Por realizar</option>
                      <option value="confirmadas">Confirmadas</option>
                      <option value="rechazadas">Rechazadas</option>
                    </select>
                  </div>

                  <Button
                    :size="17"
                    color="#28a745"
                    colorText="#ffffff"
                    tooltip="Buscar Shipping Instruction"
                    icon="fas fa-search"
                    class="mx-2 mt-4"
                    round
                    :width="35"
                    traslate
                    @click.native="getData()"
                  />

                  <Button
                    :size="17"
                    color="#28a745"
                    colorText="#ffffff"
                    tooltip="Buscar Shipping Instruction"
                    icon="fas fa-file-excel"
                    class="mx-2 mt-4"
                    round
                    :width="35"
                    traslate
                    @click.native="getData(true)"
                  />

                </div>

              </div>
            </div>
          </div>

          <new-data-table
            :headers="headers"
            :data="shippingInstructionsList"
            :acciones="[]"
            :max="10"
            paginacion
            buscar
            numerador
            idtabla="reporte_si"
          />

      </div>


      <!-- Footer -->
      <div class="d-flex justify-content-between mt-4">

        <Button
          :size="23"
          color="#c12020"
          colorText="#ffffff"
          :width="80"
          :height="35"
          text="Cerrar"
          horizontal
          @click.native="closeModal('report_si_general')"
        />

      </div>

    </ui-modal>


  </div>
</template>

<script>

// Vuex
import { mapActions } from "vuex";

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import Button from "@/components/common/Button.vue";
import { shippingInstructionsReport } from "@/constants/shippinginstructions";
import NewDataTable from "@/components/common/NewDataTable.vue";

export default {
  data() {
    return {
      headers: [
        "ID",
        "Semana",
        "Version",
        "Shipper",
        "Nave",
        "Naviera",
        "No. Booking",
        "Consignatario",
        "Viaje",
        "POD",
        "POL",
        "F. Creación",
        "Estado",
      ],
      begin: "",
      end: "",
      status: "",
      shippingInstructionsList: [],
    };
  },

  components: {
    NewDataTable,
    Button,
    UiModal,
  },

  methods: {

    ...mapActions(["ActionSetZindexModal"]),

    ...mapActions("lineas", [
      "actionSetReservaInformacionGeneralModal",
      "actionSetVisibleModalAceptarBookingDeclaradoBuscarReserva",
      "actionSetDataDatatableBookingsDeclarados",
      "actionSetDataDatatableBookingsSolicitados",
      "actionFilterDataBookingsConfirmados",
      "actionSetDataDatatableBookingsEmbarcados",
      "actionSetDatatableBookingsCancelados",
      "actionSetDataDatatableBookingsDeclaradosCancelados",
      "actionFilterDataVerMisBookingsPorAceptar",
      "actionSetDatatableBookingsPorConfirmar"
    ]),

    //gestion modal de busqueda
    async openModal(ref) {

      this.$refs[ref].open();

      await this.ActionSetZindexModal(true);

      await this.getData();


    },

    closeModal(ref) {

      this.ActionSetZindexModal(false);

      this.$refs[ref].close();

    },

    //buscar SIs
    async getData(is_report = false) {



      if (this.begin && !this.end || !this.begin && this.end) {

        return this.$vToastify.error("Se debe ingresar un rango de fechas válido", "Error: Fechas");

      }

      this.$vToastify.loader("Obteniendo registros...");
      
      try {

        const { status, data, report, message} = await shippingInstructionsReport({
          begin: this.begin ?? null,
          end: this.end ?? null,
          status: this.status ?? null,
          report: is_report
        });

        if (status === 200 && report) {

          this.shippingInstructionsList = data;

          this.$vToastify.success(message, "Éxito");

        } else if (status === 200) {

          this.shippingInstructionsList = data;

        } else {

          this.$vToastify.error("Se produjo un error al obtener los registros", "Error");

        }

        this.$vToastify.stopLoader();

      } catch (error) {

        this.$vToastify.stopLoader();

        this.$vToastify.error("Se produjo un error al obtener los registros", "Error");

        this.isLoading = false;

        this.isEmpty = true;

      }
    },
  },
  mounted() {

    this.user = JSON.parse(localStorage.getItem("user"));

  }
};
</script>

<style></style>
